import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { IComboBox } from '@sky-it-elections/design-system';

import { validateModel } from '../../utils/props-validator';

import { IComboSliderWrapperProps } from './combo-box-slider-wrapper';

const ComboBoxSliderWrapper = React.lazy(() => import('./combo-box-slider-wrapper'));

const DynamicComboBoxWrapper: React.FC<IComboSliderWrapperProps> = ({ comboBoxArray }) => (
  <Suspense fallback={<React.Fragment> ComboBoxSliderWrapper Fallback </React.Fragment>}>
    <ComboBoxSliderWrapper comboBoxArray={validateModel(comboBoxArray) as IComboBox[]} />
  </Suspense>
);

DynamicComboBoxWrapper.propTypes = {
  comboBoxArray: PropTypes.any,
};

DynamicComboBoxWrapper.defaultProps = {
  comboBoxArray: [{}] as IComboBox[],
};

export default DynamicComboBoxWrapper;
